import { useState } from "react";
import { CalendarPlus, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useVisitSettings } from "@/lib/visits";
import { CheckInDialog, PlanVisitDialog, type VisitCustomer } from "./VisitDialogs";

/** "Check in" and "Plan visit" on a lead or account page (hidden when visits are off or the user can't make them) */
export function VisitActions({ customer }: { customer: VisitCustomer }) {
  const { hasPermission } = useAuth();
  const allowed = hasPermission("visit.create");
  const settings = useVisitSettings(allowed);
  const [checkIn, setCheckIn] = useState(false);
  const [plan, setPlan] = useState(false);
  if (!allowed || !settings?.enabled) return null;
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setCheckIn(true)}>
        <MapPin className="mr-1.5 size-3.5" />
        Check in
      </Button>
      <Button variant="outline" size="icon-sm" aria-label="Plan a visit" title="Plan a visit" onClick={() => setPlan(true)}>
        <CalendarPlus className="size-3.5" />
      </Button>
      <CheckInDialog open={checkIn} onOpenChange={setCheckIn} customer={customer} />
      <PlanVisitDialog open={plan} onOpenChange={setPlan} customer={customer} />
    </>
  );
}
